// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IAlertWebhookTestResult {
	success: boolean;

	attempted: boolean;

	message: string | undefined;

	$type?: string | undefined;
}
export class AlertWebhookTestResult {
	constructor(data?: IAlertWebhookTestResult) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	success: boolean = false;

	attempted: boolean = false;

	message: string | undefined;

	static $type: string = "CoreApi.Models.Alerts.AlertWebhookTestResult, ";
	$type?: string | undefined = AlertWebhookTestResult.$type;
}

